export default __webpack_public_path__ + "static/media/Design_Blanc.d8da6c5e.jpg";